import FieldRenderer from '../FieldRenderer';
import ModuleCard from '../ModuleCard';

interface ParticipantModuleProps {
  module: {
    id: string;
    name: string;
    nameEn?: string;
    icon?: string;
    headerStyle?: string;
    headerColor?: string;
    fields: any[];
    settings: any;
  };
  event: any;
}

export default function ParticipantModule({ module }: ParticipantModuleProps) {
  return (
    <ModuleCard
      title={module.name}
      titleEn={module.nameEn}
    >
      <>
        {module.fields?.map((field) => (
          <FieldRenderer key={field.id} field={field} />
        ))}
      </>
    </ModuleCard>
  );
}
